import { createOptions } from "../components/Wizard/questions";
import { duur, niveaus, type } from "../shared/filterOptions";
import { FinderFilterType } from "../types";

export const FILTERS: FinderFilterType[] = [
  {
    label: "Vakgebied",
    key: "vakgebied",
    display: "icons",
    amountActive: 0,
    options: [
      {
        label: "ICT",
        value: "ict",
        icon: "https://cdn.sanity.io/images/6wl7gh9x/development/3cf9253bfdab8574ffb0253e7e7a76dd65a2edf6-480x480.png?w=128&h=128&fit=max",
      },
      {
        label: "Techniek",
        value: "techniek",
        icon: "https://cdn.sanity.io/images/6wl7gh9x/development/482bfddc2501b37417bdbea01896c8f5b3f0df7b-476x466.png?w=128&h=128&fit=max",
      },
      {
        label: "Creatief",
        value: "creatief",
        icon: "https://cdn.sanity.io/images/6wl7gh9x/development/f5b297c2c49c2560d4f5d54bc15fd459b92ef69e-238x233.png?w=128&h=128&fit=max",
      },
      {
        label: "Zorg en Welzijn",
        value: "zorg en welzijn",
        icon: "https://cdn.sanity.io/images/6wl7gh9x/development/adb417731c3701357353ff1967861fb3f19fd705-476x466.png?w=128&h=128&fit=max",
      },
      {
        label: "Onderwijs",
        value: "onderwijs",
        icon: "https://cdn.sanity.io/images/6wl7gh9x/development/9e1ddb1c47d4f81dbc369d60e016a7b5bb2bdc67-476x466.png?w=128&h=128&fit=max",
      },
    ],
  },
  {
    label: "Opleidingsduur",
    key: "duur",
    amountActive: 0,
    options: createOptions(duur),
  },
  {
    label: "Niveau",
    key: "niveau",
    amountActive: 0,
    options: createOptions(niveaus),
  },
  {
    label: "Type opleiding",
    key: "type",
    amountActive: 0,
    options: createOptions(type),
  },
];
